module.exports = __webpack_public_path__ + "media/images/responsive/fairs/event_detail/costume_exhibition-1e80c9c8981c9a04cfbf72706fbab9ce.jpg";